import { Component, inject, Renderer2 } from '@angular/core';
import { MainLayoutComponent } from '../main-layout/main-layout.component';
import { LayoutState } from '@/store/layout/layout-reducers';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [MainLayoutComponent],
  templateUrl: './layout.component.html',
  styles: ``,
})
export class LayoutComponent {
  layoutType: LayoutState['LAYOUT'] = '';

  private store = inject(Store);
  private render = inject(Renderer2);

  ngOnInit(): void {
    this.store.select('layout').subscribe((data: LayoutState) => {
      this.layoutType = data.LAYOUT;
      this.render.setAttribute(
        document.documentElement,
        'data-bs-theme',
        data.LAYOUT_THEME,
      );
      this.render.setAttribute(
        document.documentElement,
        'data-layout-mode',
        data.LAYOUT_MODE,
      );
      this.render.setAttribute(
        document.documentElement,
        'data-menu-color',
        data.MENU_COLOR,
      );
      this.render.setAttribute(
        document.documentElement,
        'data-topbar-color',
        data.TOPBAR_COLOR,
      );
      this.render.setAttribute(
        document.documentElement,
        'data-sidenav-size',
        data.MENU_SIZE,
      );
    });
  }

  isVerticalLayoutRequested() {
    return this.layoutType === 'vertical';
  }
}
